import Register from "../../modules/register/views/Register.vue";
import PersonalInformation from "../../modules/personal-information/views/PersonalInformation.vue";
import MedicalSpecialities from "../../modules/medical-specialities/views/MedicalSpecialities.vue";
import AttendencePlace from "../../modules/attendance-places/views/AttendencePlace.vue";
import PaymentOptions from "../../modules/payment-options/views/PaymentOptions.vue";
import TaxLicense from "../../modules/tax-license/views/TaxLicense.vue";
import RouterViewRender from "../../utils/routes/router-view-render";
import { PermissionList } from "../../static-data/PermissionList";
import { IsAbleNavigation } from "../utils/is-able-navigation";

const RegisterRoutes = {
  path: "cadastro",
  meta: {
    requiresAuth: true,
  },
  beforeEnter: (to, from, next) =>
    IsAbleNavigation(to, from, next, PermissionList.REGISTER_MENU),
  component: RouterViewRender,
  children: [
    {
      path: "",
      component: Register,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "informacoes-pessoais",
      component: PersonalInformation,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "meios-pagamento",
      component: PaymentOptions,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "impostos-alvara",
      component: TaxLicense,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "especialidades-medicas",
      component: MedicalSpecialities,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "local-atendimento",
      component: AttendencePlace,
      meta: {
        requiresAuth: true,
      },
    },
  ],
};

export default RegisterRoutes;
